module.exports = __webpack_public_path__ + "static/backgroundVideo-3b5a13cb587bd7b55ce368e3b55a5a0e.mp4";